// assets/kaira-product-wrap.js
(() => {
  document.addEventListener('DOMContentLoaded', () => {
    // Busca el form nativo del tema (Dawn usa form[action="/cart/add"])
    const pf = document.querySelector('product-form form[action="/cart/add"]');
    if (!pf) {
      console.debug('[KAIRA:product] No se encontró product-form en esta página.');
      return;
    }

    // Checkbox de envoltura (si existe)
    const wrapChk = pf.querySelector('[data-kaira-wrap]');
    // Input hidden de variante principal
    const variantInput = pf.querySelector('input[name="id"]');
    // Cantidad (Dawn usa input.quantity__input)
    const qtyInput = pf.querySelector('input[name="quantity"], input.quantity__input');

    // Datos necesarios
    const WRAP_VID = (window.KAIRA && window.KAIRA.WRAP_VID) || null; // viene desde theme.liquid
    // Estos vienen desde data-attributes en el form (ver snippet abajo)
    const PRODUCT_TITLE = pf.dataset.kairaTitle || '';
    const PRODUCT_VID   = pf.dataset.kairaVid || (variantInput?.value || '');

    console.log('[KAIRA:product] init', { WRAP_VID, PRODUCT_TITLE, PRODUCT_VID });

    // Evitar doble binding
    if (pf.dataset.kairaBound === '1') return;
    pf.dataset.kairaBound = '1';

    pf.addEventListener('submit', async (e) => {
      try {
        const wrapChecked = !!(wrapChk && wrapChk.checked);
        const selectedQty = Math.max(1, parseInt((qtyInput?.value || '1'), 10) || 1);

        console.log('[KAIRA:product] submit interceptado', {
          wrapChecked, selectedQty, PRODUCT_VID, WRAP_VID
        });

        // Si no hay envoltura marcada o no tenemos WRAP_VID -> deja el flujo normal del tema
        if (!wrapChecked || !WRAP_VID) {
          console.log('[KAIRA:product] sin envoltura, dejo submit nativo');
          return; // no preventDefault
        }

        // Tenemos que hacer el POST batch nosotros para añadir ambos ítems a la vez
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const items = [
          { id: Number(PRODUCT_VID), quantity: selectedQty },
          {
            id: Number(WRAP_VID),
            quantity: selectedQty,
            properties: {
              // Mostrará en el carrito: For: <Título del producto>
              'Para': PRODUCT_TITLE
            }
          }
        ];

        console.log('[KAIRA:product] /cart/add.js payload', { items });

        const btn = pf.querySelector('button[name="add"]');
        btn?.setAttribute('aria-busy', 'true');

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items })
        });

        if (!res.ok) {
          const t = await res.text().catch(()=>'');
          console.error('[KAIRA:product] add.js error', res.status, t);
          // fallback: intenta submit nativo
          pf.submit();
          return;
        }

        const data = await res.json().catch(() => null);
        console.log('[KAIRA:product] add.js OK', data);

        // Redirige al carrito (simple y confiable)
        window.location.href = '/cart';
      } catch (err) {
        console.error('[KAIRA:product] error en submit combinado', err);
        // fallback
        pf.submit();
      } finally {
        const btn = pf.querySelector('button[name="add"]');
        btn?.removeAttribute('aria-busy');
      }
    }, { capture: true }); // importante para ganar a los listeners de Dawn
  });
})();
